__turbopack_context__.v({
  "className": "owners_f6390f2e-module__JY09VW__className",
  "variable": "owners_f6390f2e-module__JY09VW__variable",
});
